import React from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import color from "@definitions/mui/color";

export interface IProps {
  width?: number;
  height?: number;
  top?: number;
  backgroundColor?: string;
  radius?: number;
}

const useStyles = ({ width, height, backgroundColor, top, radius }: IProps) => {
  return makeStyles(() => ({
    puller: {
      width: width ? width : 48,
      height: height ? height : 3,
      position: "absolute",
      top: top ? top : -16,
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: backgroundColor ? backgroundColor : color.grey.light,
      borderRadius: radius ? radius : 2,
    },
  }))();
};

const Puller: React.FC<IProps> = ({ width, height, backgroundColor, top, radius }) => {
  const classes = useStyles({ width, height, backgroundColor, top, radius });
  return <Box component="span" className={classes.puller} />;
};

export default Puller;
